// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:45:50+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            dccd97b615daaaf18fa8fe92a0fcfb36
//    Signature:      eyJpdiI6InVJVmxocUpGc3YxdWlaWlhRYnVqUWc9PSIsInZhbHVlIjoiWmVWMXpFSU5sREdZNVZIaDFNYnF1T1pDOFwvN3o4STNIaDhYNldyOUx4VldDd1hvdk9BUGl4Z204cWJFNjlIS2N4Vk4xc05Mc2pKM0lQYmJnWVBGNEx3T25GNDBROVF1emxlT1dZXC9ITVRubHhPRE9CWXBPV3IzenE0SG5xSTVoR0UyaWxYRFZZbHlFZWlsd0RWMDZKT244WlozN0F2NlRqXC9ZY3ZzaE5ldm1Ma0JkRXhQMFhURlhtaEkzWUVtV2JMc0hVMjdTeEhOcUd4K1lBZXgrNGR5U3BIUG9rOXhOTlRKU3p1MWZzOXJIem91RStzVVc5MnNkRW43aXNaYVJnOGVIdFEyN3hGMzVzVnRiRm9pYWdXUGZFdktjY2JPNTY3VFFqZ1l5TEloMXZHcCtIWlVEZlYxSmg3ZjhPUWRVTnBTbmo0NFZEUUlTU0hHcW5tSFNcL2lQSUptY0ZLRjZYenBkRTNBUUJvS3N1SDBQRW43bVhsZE02UUxQaHdhMVlOVHlieEl6RE1hbzEyV0p3R1pSV2dKcDFOS1VMVmk0VWhIYnJuZ2w2blp3Y3M9IiwibWFjIjoiNzhjZTNiYWU4ZjQ4YTJhYjc0MjIyZWFhZWQ3MjE4MmIzNzAwZGY1ZDYwYzc4OTA0MWYxMjNmNjU2OTk5OTU2MSJ9
$(document).ready(function () {
    let x=8;
    let to_show = 8;
    let size_li = $(".accordion-item.active").length;
    if (size_li > to_show) {
      $('.load-more-module').removeClass('hide')
    }
    let percentage = (x / size_li)*100;
    $('.fill').css('width', percentage+'%');
    $('.accordion-item.active:lt('+x+')').removeClass('hide');
    $('.accordion-item.active:lt('+x+')').addClass('active');
    $('#viewed-count').html(x)
    $('.loadMore').click(function () {
        x= (x+to_show <= size_li) ? x+to_show : size_li;
        $('#viewed-count').html(x)
        percentage = (x / size_li)*100;
        $('.fill').css('width', percentage+'%');
        $('.accordion-item.active:lt('+x+')').removeClass('hide');
        $('.accordion-item.active:lt('+x+')').addClass('active');
        if(x == size_li){
            $('.fill').css('width', '100%');
            $('.loadMore').hide();
        }
    });
  });
